import React from 'react';

function CombinedClientScopeFilters({
  clientOptions,
  clientsLoading,
  clientScopeMode,
  selectedClientIds,
  effectiveClientIds,
  financialYear,
  onScopeModeChange,
  onToggleClientId,
}) {
  return (
    <section className="combined-scope-card">
      <div className="combined-scope-card__header">
        <div>
          <p className="consolidated-reports-eyebrow">Client Scope</p>
          <h3>Run this report for all accessible clients or narrow it to a selected list.</h3>
          <p>The combined section stays independent from the single-client selector in the main header.</p>
        </div>
        <div className="combined-scope-card__summary">
          <span>Included</span>
          <strong>{effectiveClientIds.length > 0 ? effectiveClientIds.join(', ') : 'None'}</strong>
          <small>{financialYear ? `FY ${financialYear}` : 'Select a financial year from the header'}</small>
        </div>
      </div>

      <div className="combined-scope-card__modes" role="radiogroup" aria-label="Combined report client scope">
        <label className={`combined-scope-card__mode${clientScopeMode === 'all' ? ' combined-scope-card__mode--active' : ''}`}>
          <input
            type="radio"
            name="combined-client-scope"
            checked={clientScopeMode === 'all'}
            onChange={() => onScopeModeChange('all')}
          />
          <span>All accessible clients</span>
        </label>

        <label className={`combined-scope-card__mode${clientScopeMode === 'selected' ? ' combined-scope-card__mode--active' : ''}`}>
          <input
            type="radio"
            name="combined-client-scope"
            checked={clientScopeMode === 'selected'}
            onChange={() => onScopeModeChange('selected')}
          />
          <span>Selected clients only</span>
        </label>
      </div>

      {clientsLoading && clientOptions.length === 0 ? (
        <p className="financial-message">Loading client access…</p>
      ) : null}

      {!clientsLoading && clientOptions.length === 0 ? (
        <p className="financial-message financial-message--error">No client IDs are available yet. Add client access in the profile to use combined reporting.</p>
      ) : null}

      {clientScopeMode === 'selected' && clientOptions.length > 0 ? (
        <div className="combined-scope-card__chips">
          {clientOptions.map((option) => {
            const checked = selectedClientIds.includes(option.value);
            return (
              <label
                key={option.value}
                className={`combined-scope-chip${checked ? ' combined-scope-chip--active' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => onToggleClientId(option.value)}
                />
                <span>{option.label}</span>
              </label>
            );
          })}
        </div>
      ) : null}

      {clientScopeMode === 'all' && clientOptions.length > 0 ? (
        <p className="combined-scope-card__note">All client IDs currently available in your profile are included automatically.</p>
      ) : null}

      {clientScopeMode === 'selected' && clientOptions.length > 0 && effectiveClientIds.length === 0 ? (
        <p className="financial-message financial-message--error">Select at least one client ID to load the combined report.</p>
      ) : null}
    </section>
  );
}

export default CombinedClientScopeFilters;